export const PlatformOptions = [
  { value: 'anymarket', text: 'ANYMARKET' },
  { value: 'occ', text: 'OCC' }];

export default PlatformOptions;
